import { HpError } from '@avantia/logging-and-errors';
import { BaseSyntheticEvent } from 'react';
import { triggerLinkFollowedEvent } from '../../../actions/eventActions';

export function ExternalLink({ children, className, content, href, id }: HpExternalLinkProps): JSX.Element {
  if (!!children && !!content) {
    throw new HpError(`ExternalLink component can have either 'content' or 'children' but not both.`);
  }

  let link: HTMLAnchorElement | null = null;
  const handler = (event: BaseSyntheticEvent) => {
    triggerLinkFollowedEvent({ getEvent: () => event, link: link as HTMLAnchorElement });
  };

  const onKeyPressFunc = (e: BaseSyntheticEvent) => {
    window.open(link as any, '_blank');
    handler(e);
  };

  return (
    <a
      id={id}
      ref={(ref: HTMLAnchorElement | null) => (link = ref)}
      className={className}
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      onClick={handler}
      onAuxClick={handler}
      onContextMenu={handler}
      onKeyPress={onKeyPressFunc}
      tabIndex={0}
    >
      {children || content || href}
    </a>
  );
}

export interface HpExternalLinkProps {
  children?: string | JSX.Element | JSX.Element[];
  className?: string;
  content?: JSX.Element | string;
  href: string;
  id: string;
}
